<template>
  <router-link
    :to="{ name: `report-${this.$i18n.locale}`, params: { ...this.product, lang: this.$i18n.locale } }"
    :class="[$attrs.class]"
    :name="this.product.id"
  >
    <span class="card-img-top" :class="this.product.icon" />
    <span class="card-title">{{ this.product.title }}</span>
    <template v-if="this.product.services">
      <table class="card-table">
        <tbody>
          <tr v-for="service in this.product.services" :key="service.code">
            <td class="text-center text-md-start d-table-cell card-text">
              {{ this.product.serviceDetails[service.code].shortTitle }}
            </td>
            <td class="card-text fw-bold text-end d-none d-md-table-cell">
              {{ $price(service.price) }}
            </td>
          </tr>
        </tbody>
      </table>
      <span class="card-footer text-center">
        <a href="#" class="card-link icon-double-arrow-right float-none">
          {{ $t('more') }}
        </a>
      </span>
    </template>
    <template v-else>
      <span class="card-text" :class="subscriptionClass" v-html="this.product.promo" />
      <span class="card-footer">
        <span class="card-info">
          <template v-if="this.product.subscriptions">
            {{ $priceStartsFrom($price($pricePerPeriod(this.product.subscriptions))) }}
          </template>
          <template v-else>{{ this.$price(product.price) }}</template>
        </span>
        <span class="card-link icon-double-arrow-right">{{ $t('more') }}</span>
      </span>
    </template>
  </router-link>
</template>

<script>
export default {
  props: {
    product: { type: Object, required: true },
    subscriptionClass: String,
  },
};
</script>
